﻿import { useEffect, useState, useRef } from 'react';
import { moduleClientFactory } from '../../api-service/module-client-factory';
import { win } from '../../utilities';
import { sanitizeHtml } from '../../utilities/sanitize-html';
import { CircularProgress } from '../circular-progress';
import { AbsolutelyCentered } from '../absolutely-centered';
import './legal-document-viewer.scss';

interface ViewerState {
  htmlContent: string;
  errorMessage: string;
  isLoading: boolean;
}

export function LegalDocumentViewer(props: { documentId: string }) {
  const { documentId } = props;
  const client = moduleClientFactory.createAiSearchClient();
  const contentRef = useRef<HTMLDivElement>(null);

  const [viewerState, setViewerState] = useState<ViewerState>({ isLoading: true, errorMessage: '', htmlContent: '' });

  useEffect(() => {
    client
      .getLegalDocumentFileByIdentifier({ documentId })
      .then(async res => {
        const htmlContent = await res.data.text();
        setViewerState(prevState => ({ ...prevState, htmlContent, isLoading: false }));
      })
      .catch(reason => {
        setViewerState(prevState => ({ ...prevState, errorMessage: `'Der skete en fejl ved indlæsning af dokumentet.\n ${reason}`, isLoading: false }));
      });
  }, []);

  useEffect(() => {
    if (!viewerState.htmlContent || viewerState.isLoading || !win.location.hash || win.location.hash === '#' || !contentRef.current) {
      return;
    }

    const hash = win.location.hash.substring(1); // Remove the '#' prefix

    setTimeout(() => {
      const targetElement = contentRef.current?.querySelector(`#${hash}`);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  }, [viewerState.htmlContent, viewerState.isLoading]);

  if (viewerState.isLoading) {
    return (
      <AbsolutelyCentered>
        <CircularProgress />
      </AbsolutelyCentered>
    );
  }
  if (viewerState.errorMessage) {
    return (
      <AbsolutelyCentered>
        <p>{viewerState.errorMessage}</p>
      </AbsolutelyCentered>
    );
  }
  return (
    <div
      className="legal-document-viewer-document-container"
      ref={contentRef}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(viewerState.htmlContent) }}
      style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(241, 235, 228)' }}
    ></div>
  );
}
